import { computed }          from 'mobx';
import NewFondationsApiModel from 'models/global/NewFondationsApiModel';

type EntityStatusReferences = 'ENABLED' | 'DISABLED' | 'BLACKLISTED';

export default class EntityStatusModel extends NewFondationsApiModel {
	static get path(): string {
		return '/entity_statuses/{?id}';
	}

	@computed
	get label() {
		return this.get('label');
	}

	get reference(): EntityStatusReferences {
		return this.get('reference');
	}

	get color() {
		if (this.reference === 'ENABLED') {
			return 'green';
		}
		if (this.reference === 'DISABLED') {
			return 'red';
		}
		if (this.reference === 'BLACKLISTED') {
			return 'black';
		}
	}
}
